import * as React from 'react';
import FilterOutlined from './filter-outlined';
import FilterFilled from './filter-filled';
import type { IconCombinedProps } from './types';
const FilterCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <FilterFilled ref={ref} {...rest} />;
  }
  return <FilterOutlined ref={ref} {...rest} />;
});
export default FilterCombined;